import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import renderViewsState from '../shared/render-views-state';
import Animate from '../shared/animation';

import EditForm from './components/form';
import { selectors as rootSelectors } from '../root';

const Main = renderViewsState(props => (
	<Animate>
		<div className="container__content cpl-rules-create">
			<div className="container__content-title clearfix">
				<div className="container__content-title-position">
					<Link to='geo-payout-rates/' className="link">
						{ props.intl('Return to list of restricted geo payouts') }
					</Link>
				</div>
			</div>
			<div className="container__content-body">
				<div className="form-container">
					<EditForm
						{...props}
						location_path={props.router.getCurrentLocation().pathname}
						initialValues={props.formData}
					/>
				</div>
			</div>
		</div>
	</Animate>
), 'geoPayoutRatesEdit');

export default connect(
	state => ({
		data: selectors.getData(state),
		formData: selectors.getGeoPayoutRate(state),
		progressBar: selectors.getProgressBar(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		payoutCurrencies: selectors.getPayoutCurrencies(state),
		error: selectors.getError(state),
		can: selectors.getCan(state),
		intl: selectors.getIntl(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/geo-payout-rates/edit.js